<template>
  <v-text-field
    color="secondary"
    single-line
    variant="underlined"
    :label="$t('Search')"
    :name="fieldKey"
    type="text"
    :hint="hint"
    :loading="loading"

    :model-value="modelValue"
    clearable
    :disabled="disabled"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #prepend>
      <v-icon>
        mdi-magnify
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
  import InputMixin from './InputMixin'

  export default {
    mixins: [InputMixin],
    props: {
      loading: Boolean
    },
    emits: ['update:model-value']
  }
</script>
